import {
  Building2,
  Home,
  Expand,
  Zap,
  Wrench,
  ChefHat,
  Bath,
  Grid3X3,
} from "lucide-react";

export const COMPANY = {
  name: "Krishnaa Constructions",
  brand: "KAC",
  tagline: "All Types of Building Work",
  contact: "Amit Patel",
  phone: "07823449666",
  phoneDisplay: "+44 7823 449666",
  email: "kacpatel6@gmail.com",
  whatsapp: "https://wa.me/447823449666",
  areas: "Greater London & surrounding areas",
};

export const WHATSAPP_MSG =
  "Hello KAC — Krishnaa Constructions, I found your website and would like to enquire about a building project. Could you please contact me about a quote?";

export const waLink = (msg = WHATSAPP_MSG) =>
  `${COMPANY.whatsapp}?text=${encodeURIComponent(msg)}`;

export const IMAGES = {
  hero: "https://images.pexels.com/photos/28184693/pexels-photo-28184693.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  loft: "https://images.pexels.com/photos/7045302/pexels-photo-7045302.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kitchen: "https://images.pexels.com/photos/38310837/pexels-photo-38310837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bathroom:
    "https://images.unsplash.com/photo-1561817223-f67e69e6bd6a?crop=entropy&cs=srgb&fm=jpg&q=85",
  extension:
    "https://images.pexels.com/photos/30924413/pexels-photo-30924413.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tiling:
    "https://images.unsplash.com/photo-1625578622297-56606e41830f?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICES = [
  {
    id: "general-building",
    title: "General Building Work",
    icon: Building2,
    desc: "Brickwork, blockwork, structural alterations, repairs and complete property refurbishments — all types of building work under one roof.",
    points: ["Brick & blockwork", "Structural alterations", "Repairs & refurbishments"],
  },
  {
    id: "loft-conversions",
    title: "Loft Conversions",
    icon: Home,
    desc: "Turn unused attic space into bright bedrooms, home offices or master suites that add real space and value to your home.",
    points: ["Dormer conversions", "Velux & rooflight", "Hip-to-gable"],
  },
  {
    id: "house-extensions",
    title: "House Extensions",
    icon: Expand,
    desc: "Single and double-storey rear and side extensions designed around how you live, built with care from foundations to finish.",
    points: ["Single & double storey", "Side return extensions", "Open-plan kitchen spaces"],
  },
  {
    id: "electrical",
    title: "Electrical Services",
    icon: Zap,
    desc: "From additional sockets and lighting to full and partial rewires, carried out neatly and tested in line with UK wiring regulations.",
    points: ["Full & partial rewires", "Lighting installation", "Sockets, switches & fuse boards"],
  },
  {
    id: "plumbing",
    title: "Plumbing Services",
    icon: Wrench,
    desc: "Everyday plumbing done properly — taps, toilets, radiators, pipework, leaks and full bathroom and kitchen first and second fix.",
    points: ["Bathroom & kitchen pipework", "Radiators & heating pipework", "Leak repairs"],
  },
  {
    id: "kitchen-renovations",
    title: "Kitchen Renovations",
    icon: ChefHat,
    desc: "Complete kitchen strip-out and installation — units, worktops, tiling, plumbing and electrics coordinated by one team.",
    points: ["Full kitchen fitting", "Worktops & splashbacks", "Appliance installation"],
  },
  {
    id: "bathroom-renovations",
    title: "Bathroom Renovations",
    icon: Bath,
    desc: "Stylish bathrooms, en-suites and wet rooms — from rip-out to the final silicone line, including tiling and plumbing.",
    points: ["Full bathroom refits", "En-suites & wet rooms", "Tiling & flooring"],
  },
  {
    id: "tiling",
    title: "Wall & Floor Tiling",
    icon: Grid3X3,
    desc: "Precise wall and floor tiling in ceramic, porcelain and natural stone, with clean lines and a finish that lasts.",
    points: ["Porcelain & ceramic", "Natural stone", "Kitchens, bathrooms & floors"],
  },
];

export const PROJECTS = [
  {
    id: "p1",
    title: "Dormer Loft Conversion",
    category: "Loft Conversions",
    location: "Greater London",
    image: IMAGES.loft,
    desc: "An example of the loft conversion projects KAC undertakes — creating a bright new floor within an existing roof space.",
  },
  {
    id: "p2",
    title: "Rear House Extension",
    category: "Extensions",
    location: "Greater London",
    image: IMAGES.extension,
    desc: "An example of the rear and side extensions KAC builds — opening up ground-floor living space to the garden.",
  },
  {
    id: "p3",
    title: "Full Kitchen Renovation",
    category: "Kitchens",
    location: "Greater London",
    image: IMAGES.kitchen,
    desc: "An example of KAC kitchen renovations — complete strip-out, fitting, tiling and finishing by one coordinated team.",
  },
  {
    id: "p4",
    title: "Bathroom Renovation",
    category: "Bathrooms",
    location: "Greater London",
    image: IMAGES.bathroom,
    desc: "An example of KAC bathroom renovations — from rip-out and plumbing to tiling and the final finish.",
  },
  {
    id: "p5",
    title: "Wall & Floor Tiling",
    category: "Tiling",
    location: "Greater London",
    image: IMAGES.tiling,
    desc: "An example of KAC tiling work — precise wall and floor tiling across kitchens, bathrooms and living spaces.",
  },
  {
    id: "p6",
    title: "General Building Work",
    category: "General Building",
    location: "Greater London",
    image: IMAGES.hero,
    desc: "An example of the general building projects KAC delivers — repairs, alterations and refurbishments of every size.",
  },
];

export const PROJECT_CATEGORIES = [
  "All",
  "Loft Conversions",
  "Extensions",
  "Kitchens",
  "Bathrooms",
  "Tiling",
  "General Building",
];

export const BUDGET_OPTIONS = [
  "Under £5,000",
  "£5,000 – £10,000",
  "£10,000 – £25,000",
  "£25,000 – £50,000",
  "£50,000+",
  "Not sure yet",
];
